import { fetchWithTimeout, processApiResponse } from "@/core/utils";

const fetchOptions: object = {
  headers: {
    "Content-Type": "application/json",
    method: "GET",
  },
};

const signatureApi = {
  getPassengersDataByDocumentId: async (documentId: string) => {
    const response: Response = await fetchWithTimeout(
      `api/getPassengersDataByDocumentId/${documentId}`,
      {
        ...fetchOptions,
      }
    );
    return processApiResponse(response);
  },
};

export { signatureApi };
